import React, { RefObject, useEffect, useRef } from 'react';

import { applyBgLightColor } from '../../utils/utils';
import { classNames } from '../../utils/style';
import { PayFitColor } from '../../types/module';
import { LinkObfuscated } from '../../utils/obfuscation/LinkObfuscated';

interface TrustpilotObject {
  loadFromElement: (ref: RefObject<HTMLElement> | null, bool: boolean) => void;
}
declare global {
  interface Window {
    Trustpilot?: TrustpilotObject;
  }
}
export interface TrustpilotWidgetProps {
  trustpilotUrl: string;
  backgroundColor?: PayFitColor;
  className?: string;
  widgetType: string;
}

export const TrustpilotWidget = ({
  trustpilotUrl,
  backgroundColor,
  className,
  widgetType,
}: TrustpilotWidgetProps) => {
  let param: {
    templateId: string;
    styleHeight: string;
    styleWidth: string;
  };

  if (widgetType === 'mini') {
    param = {
      templateId: '53aa8807dec7e10d38f59f32',
      styleHeight: '150px',
      styleWidth: '100%',
    };
  } else {
    // horizontal
    param = {
      templateId: '5406e65db0d04a09e042d5fc',
      styleHeight: '28px',
      styleWidth: '100%',
    };
  }

  const ref = useRef(null);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <section
      className={classNames(applyBgLightColor(backgroundColor), className)}
    >
      <div
        ref={ref}
        className={`trustpilot-widget`}
        data-locale="es-ES"
        data-template-id={param.templateId}
        data-businessunit-id="61043fce96798b001dd1f963"
        data-style-height={param.styleHeight}
        data-style-width={param.styleWidth}
        data-theme="light"
      >
        <LinkObfuscated href={trustpilotUrl} blank={true}>
          Trustpilot
        </LinkObfuscated>
      </div>
    </section>
  );
};
